import React, { useEffect, useRef, useState } from "react";
import CustomDropdown from "../../../../../components/Dropdown";
import CreateTransactionModal from "./createTransaction";
import AddItemModal from "./addItem";
import { ProgressSpinner } from "primereact/progressspinner";
import { Toast } from "primereact/toast";
import DocumentsComponent from "./luxaryAssetsComponent/documentsComponent";
import PictureComponent from "./luxaryAssetsComponent/pictureCompoenent";
import MovementComponent from "./luxaryAssetsComponent/movementComponent";
import JournalComponent from "./luxaryAssetsComponent/journalComponent";
import LegacyComponent from "./luxaryAssetsComponent/legacyComponent";
import {
  formatNumber,
  getBreadcrumbLabelsByAssetType,
  getDropdownLabelsByAssetType,
  getTabLabelsByAssetType,
  HorizontalTabButtons,
  truncateText,
  truncateToTwoDecimals,
} from "../../../../../utility/helper";
import {
  deleteMediaService,
  deleteTransaction,
} from "../../../../../services/transaction";
import ConfirmDialog from "../../../../../components/ConfirmDialog";
import {
  addMediaService,
  getItemsService,
  getJournalService,
  getLegaciesService,
  getLuxaryTransaction,
  getMediaService,
} from "../../../../../services/legacy/legacyApi";
import {
  clearSelectedAsset,
  fetchUserAssets,
  setSelectedAsset,
} from "../../../../../redux/slices/userAssetsSlice";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { handleErrorRedirect } from "../../../../../utility/errorRedirect";
import Breadcrumb from "../../../../../components/Breadcrumb";
import AssetGuardedActionButton from "../../../../../components/AddTransactionButton";
import LuxuryAssetSkeleton from "./luxaryAssetsComponent/luxuryAssetSkelton";

const ViewTransaction = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [luxuryLoading, setLuxuryLoading] = useState(false);
  const [mediaLoading, setMediaLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [dialogConfig, setDialogConfig] = useState({});
  const allDropdownOptions = getDropdownLabelsByAssetType("4");
  const breadcrumbItems = getBreadcrumbLabelsByAssetType("Luxury Assets");
  const { currency } = useSelector((state) => state.user);

  const [type, setType] = useState("");
  const [singleTransactionData, setSingleTransactionData] = useState({});
  const [limit, setLimit] = useState(20);
  const [error, setError] = useState(null);
  const [page, setPage] = useState(0);
  const [viewTransaction, setViewTransaction] = useState([]);
  const [mediaData, setMediaData] = useState([]);
  const [legaciesData, setLegaciesData] = useState([]);
  const [addItems, setAddItems] = useState([]);
  const [items, setItems] = useState("");
  const [documentLimit, setDocumentLimit] = useState(5);
  const [documentPage, setDocumentPage] = useState(0);
  const [journalData, setJournalData] = useState([]);
  const [actionTypes, setActionTypes] = useState("Create");
  const [selectedButton, setSelectedButton] = useState("Pictures");
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const toast = useRef(null);
  const dispatch = useDispatch();
  const userAssets = useSelector((state) => state.userAssets.data);
  const { selectedAsset, userAssetLoading } = useSelector(
    (state) => state.userAssets
  );
  const location = useLocation();
  const id = location?.state?.id || null;
  const sell = viewTransaction?.transactions?.find(
    (item) => item.type === "SELL"
  );
  const dropdownOptions = items?.id
    ? allDropdownOptions.filter((option) => option.name !== "ADD ITEM")
    : allDropdownOptions;
  const navigate = useNavigate();
  const tabOptions = getTabLabelsByAssetType("4");

  useEffect(() => {
    dispatch(fetchUserAssets({ assetTypeId: 4, selectedAssetId: id })).then(
      (resultAction) => {
        if (fetchUserAssets.rejected.match(resultAction)) {
          const status = resultAction?.payload?.status;
          handleErrorRedirect(status, navigate);
        }
      }
    );
    return () => {
      dispatch(clearSelectedAsset());
    };
  }, [dispatch, id]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  useEffect(() => {
    if (selectedAsset) {
      GetAddedItemData();
    }
  }, [selectedAsset]);

  useEffect(() => {
    if (selectedAsset && items) {
      GetTransactionData();
      GetJournalData();
      GetLegaciesData();
    }
  }, [selectedAsset, items, page]);

  useEffect(() => {
    if (
      (selectedButton === "Pictures" || selectedButton === "Documents") &&
      items
    ) {
      GetMediaData();
    }
  }, [selectedButton, selectedAsset, page, items]);

  const openConfirmDialog = (config) => {
    setDialogConfig(config);
    setIsDialogOpen(true);
  };

  const handleOptionSelect = (option, actionTypes, data) => {
    setModalVisible(true);
    setType(option);
    setActionTypes(actionTypes);
    setSingleTransactionData(data);
  };

  const GetMediaData = async () => {
    const mediaType = selectedButton === "Pictures" ? "image" : "file";
    setLoading(true);
    try {
      const response = await getMediaService(
        selectedAsset?.id,
        items.id,
        mediaType,
        accessToken
      );
      if (response.status === 200) {
        const data = response?.data.data;
        setMediaData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetAddedItemData = async () => {
    setLoading(true);
    try {
      const response = await getItemsService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setAddItems(data);
        if (data.length > 0) {
          setItems(data[0]);
        } else {
          setItems(null);
        }
      } else {
        throw new Error("Failed to fetch items data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetJournalData = async () => {
    setLoading(true);
    try {
      const response = await getJournalService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setJournalData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetLegaciesData = async () => {
    setLoading(true);
    try {
      const response = await getLegaciesService(selectedAsset?.id, accessToken);
      if (response.status === 200) {
        const data = response?.data.data;
        setLegaciesData(data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLoading(false);
    }
  };

  const GetTransactionData = async () => {
    setLuxuryLoading(true);
    setError(null);
    try {
      const response = await getLuxaryTransaction(
        selectedAsset?.id,
        items.id,
        page * limit,
        limit,
        "All",
        accessToken
      );
      if (response.status === 200) {
        setViewTransaction(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      setError(err.message || "An error occurred");
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
    } finally {
      setLuxuryLoading(false);
    }
  };

  const handleTransactionDelete = async (user) => {
    try {
      const accessToken = JSON.parse(localStorage.getItem("access_token"));
      const response = await deleteTransaction(accessToken, user?.id);
      if (response) {
        dispatch(fetchUserAssets({ assetTypeId: 4, selectedAssetId: id }));
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: "transaction deleted successfully",
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleMediaDelete = async (media_id, fileType) => {
    try {
      const response = await deleteMediaService(accessToken, media_id);
      if (response) {
        GetMediaData();
        dispatch(fetchUserAssets({ assetTypeId: 4, selectedAssetId: id }));
        GetTransactionData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: `${fileType ? fileType : "Media"} deleted successfully`,
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    }
  };

  const handleCreateMedia = async (media) => {
    const mediaType = selectedButton === "Pictures" ? "image" : "file";
    if (selectedButton === "Documents") {
      setMediaLoading(true);
    }
    if (!items?.id) {
      setMediaData([]);
      setMediaLoading(false);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: "Please add a Luxuary item first before uploading any file.",
        life: 2000,
      });
      return;
    }

    try {
      const response = await addMediaService(
        media,
        selectedAsset?.id,
        items.id,
        mediaType,
        accessToken
      );
      if (response) {
        GetMediaData();
        GetTransactionData();
        GetJournalData();
        GetLegaciesData();
        toast.current.show({
          className: "bg-green-300 text-white",
          severity: "success",
          summary: "Success",
          detail: `${mediaType} upload successfully`,
          life: 3000,
        });
      }
    } catch (err) {
      const status = err?.response?.status;
      handleErrorRedirect(status, navigate);
      toast.current.show({
        className: "bg-yellow-700 text-white",
        severity: "warn",
        summary: "Warning",
        detail: err.message,
        life: 3000,
      });
    } finally {
      if (selectedButton === "Documents") {
        setMediaLoading(false);
      }
    }
  };

  const confirmMediaDelete = (mediaId, fileType) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: `Are you sure you want to delete this ${
        fileType ? fileType : "Media"
      }?`,
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleMediaDelete(mediaId, fileType),
    });
  };

  const confirmTransactionDelete = (transactionId) => {
    openConfirmDialog({
      title: "Confirm Delete",
      message: "Are you sure you want to delete this transaction?",
      confirmText: "Delete",
      cancelText: "Cancel",
      cancelClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium border dark:border-gray-300 border-info rounded-md bg-transparent text-info dark:text-grey rounded-md focus:outline-none",
      confirmClass:
        "ml-6 inline-flex justify-center px-4 py-2 items-center gap-1 text-sm font-medium dark:text-black dark:button-primary-gradient rounded-md bg-lightPrimary text-white rounded-md focus:outline-none",
      onConfirm: () => handleTransactionDelete(transactionId),
    });
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog
        isOpen={isDialogOpen}
        setIsOpen={setIsDialogOpen}
        {...dialogConfig}
      />
      <div
        className={`relative ${
          mediaLoading ? "opacity-50 pointer-events-none" : ""
        }`}
      >
        {/* <Breadcrumb items={breadcrumbItems} className="md:ml-5 mb-2" /> */}

        <div className="font-bold flex items-center flex-row justify-between px-4">
          <HorizontalTabButtons
            buttons={tabOptions}
            selected={selectedButton}
            onSelect={setSelectedButton}
          />
          {/* <div>
            <CustomDropdown
              options={dropdownOptions}
              name={""}
              assetId={""}
              icon={<FaPlus />}
              direction={"right"}
              truncateText={truncateText}
              size={19}
              className={`flex items-center border border-lightPrimary dark:border-none justify-center w-10 h-9 font-bold rounded-md 
              ${
                sell
                  ? "bg-gray-400 dark:bg-gray-600 text-white cursor-not-allowed border-none"
                  : "bg-expense text-white dark:text-black dark:button-primary-gradient"
              }
            `}
              onOptionSelect={(option) =>
                !sell && handleOptionSelect(option, "Create", {})
              }
              disabled={!!sell}
            />
          </div> */}
          <AssetGuardedActionButton
            userAssets={userAssets}
            onOptionSelect={handleOptionSelect}
            dropdownOptions={dropdownOptions}
            truncateText={truncateText}
            setIsDialogOpen={setIsDialogOpen}
            openConfirmDialog={openConfirmDialog}
            navigate={navigate}
            navigatePath="/my-view"
            assetsName={"Luxury Asset"}
            disabled={!!sell}
            sell={sell}
          />
        </div>
        <div className="border border-lightPrimary/40 dark:border-info/40 p-3 mx-4 my-3 dark:bg-card-custom-radials bg-[length:100%_200%] bg-white">
          <div>
            <CustomDropdown
              options={userAssets}
              name={selectedAsset?.name || "Select Asset"}
              assetId={selectedAsset?.id || null}
              onOptionSelect={(option) => dispatch(setSelectedAsset(option))}
              returnFullObject={true}
              truncateText={truncateText}
              size={19}
              disabled={!selectedAsset || !selectedAsset.name}
              className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 py-1.5  items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-dark"
            />
          </div>
          {selectedButton === "Journal" ? (
            <div className="grid grid-cols-1 md:grid-cols-3">

              <div className="ml-1 break-words text-info dark:text-white text-2xl text-lightPrimary dark:text-primary-gradient">
                {selectedAsset?.name ?? ""}
              </div>

              <div className="grid grid-cols-2 col-span-1 md:col-span-2">
                <div className="ml-1 break-words text-info dark:text-grey text-center border-b text-3xl md:mt-[-21px] border-info mt-4">
                  Journal
                </div>

                <div
                  className={`text-2xl md:mt-[-16px] mt-4 justify-around flex gap-5 ${
                    Number(journalData?.total_roi ?? 0) >= 0
                      ? "text-lightPrimary dark:text-primary-gradient"
                      : "text-expense dark:text-warning"
                  }`}
                >
                  <div className="text-end">ROI</div>
                  <span className="text-2xl break-all font-medium">
                    {formatNumber(
                      truncateToTwoDecimals(
                        Math.abs(Number(journalData?.total_roi ?? 0))
                      )
                    )}
                    %
                  </span>
                </div>
              </div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {/* <div className="ml-1 text-2xl text-lightPrimary dark:text-primary-gradient">
                {selectedAsset?.name}
                {selectedAsset && (
                  <div className="text-gray-400">
                    <CustomDropdown
                      options={addItems}
                      name={items ? items.name : "Select Items"}
                      assetId={items ? items.id : "Select Items"}
                      onOptionSelect={(option) => {
                        setItems(option);
                      }}
                      returnFullObject={true}
                      truncateText={truncateText}
                      size={19}
                      disabled={!items || !items.name}
                      className="inline-flex whitespace-nowrap disabled:cursor-not-allowed disabled:dark:opacity-75 disabled:border-none justify-center px-1 items-center gap-1 text-[0.65rem] font-medium bg-transparent rounded-md text-lightPrimary dark:text-white border border-transparent hover:border-primary"
                    />
                  </div>
                )}
              </div> */}
              {luxuryLoading || userAssetLoading || !viewTransaction ? (
                <LuxuryAssetSkeleton />
              ) : (
                <>
                  <div className="space-y-5 text-info dark:text-grey text-sm">
                    <div className="flex justify-between items-baseline gap-24 w-fit max-w-[25rem]">
                      <span className="whitespace-nowrap mr-1">Value:</span>
                      <span className="text-2xl text-lightPrimary break-all dark:text-primary-gradient font-medium">
                        {formatNumber(
                          truncateToTwoDecimals(
                            Number(viewTransaction?.current_value ?? 0)
                          )
                        )}{" "}
                        {currency ? currency : ""}
                      </span>
                    </div>
                    <div className="space-y-1">
                      <div className="flex justify-between items-baseline gap-5 w-fit max-w-[25rem]">
                        <span className="whitespace-nowrap">
                          Acquisition Price:
                        </span>
                        <span className="text-2xl text-lightPrimary break-all dark:text-primary-gradient font-medium break-anywhere">
                          {formatNumber(
                            truncateToTwoDecimals(
                              Number(viewTransaction?.initial_balance ?? 0)
                            )
                          )}{" "}
                          {currency ? currency : ""}
                        </span>
                      </div>
                    </div>
                  </div>

                  <div className="space-y-3 text-sm text-info dark:text-grey">
                    <div className="flex justify-between items-baseline gap-4 w-fit max-w-[25rem]">
                      <span className="mr-1">
                        {Number(viewTransaction?.crr ?? 0) >= 0
                          ? "Gain:"
                          : "Loss:"}
                      </span>
                      <span
                        className={`text-2xl break-all font-medium ${
                          Number(viewTransaction?.crr ?? 0) >= 0
                            ? "text-lightPrimary dark:text-primary-gradient"
                            : "text-expense dark:text-warning"
                        }`}
                      >
                        {formatNumber(
                          truncateToTwoDecimals(
                            Math.abs(Number(viewTransaction?.crr ?? 0))
                          )
                        )}{" "}
                        {currency ? currency : ""}
                      </span>
                    </div>
                    <div className="flex justify-between items-baseline gap-5 w-fit max-w-[25rem]">
                      <span className="mr-1">ROI:</span>
                      <span
                        className={`text-2xl break-all font-medium ${
                          Number(viewTransaction?.roi ?? 0) >= 0
                            ? "text-lightPrimary dark:text-primary-gradient"
                            : "text-expense dark:text-warning"
                        }`}
                      >
                        {formatNumber(
                          truncateToTwoDecimals(
                            Math.abs(Number(viewTransaction?.roi ?? 0))
                          )
                        )}
                        %
                      </span>
                    </div>
                  </div>

                  <div className="grid grid-col-2 text-sm text-info dark:text-grey">
                    <div className="space-y-3">
                      <div className="flex justify-between items-baseline gap-8 w-fit max-w-[25rem]">
                        <span className="whitespace-nowrap">
                          {Number(viewTransaction?.realized ?? 0) >= 0
                            ? "Realised Profit:"
                            : "Realised Loss:"}
                        </span>

                        <span
                          className={`text-2xl text-wrap font-medium break-all ${
                            Number(viewTransaction?.realized ?? 0) >= 0
                              ? "text-lightPrimary dark:text-primary-gradient"
                              : "text-expense dark:text-warning"
                          }`}
                        >
                          {formatNumber(
                            truncateToTwoDecimals(
                              Math.abs(Number(viewTransaction?.realized ?? 0))
                            )
                          )}{" "}
                          {currency || ""}
                        </span>
                      </div>

                      <div className="flex justify-between items-baseline gap-4 w-fit max-w-[25rem]">
                        <span className="whitespace-nowrap">
                          {Number(viewTransaction?.unrealized ?? 0) >= 0
                            ? "Unrealised Profit:"
                            : "Unrealised Loss:"}
                        </span>

                        <span
                          className={`text-2xl font-medium break-all ${
                            Number(viewTransaction?.unrealized ?? 0) >= 0
                              ? "text-lightPrimary dark:text-primary-gradient"
                              : "text-expense dark:text-warning"
                          }`}
                        >
                          {formatNumber(
                            truncateToTwoDecimals(
                              Math.abs(Number(viewTransaction?.unrealized ?? 0))
                            )
                          )}{" "}
                          {currency ? currency : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="grid grid-col-2 text-sm text-info dark:text-grey">
                    <div className="space-y-3">
                      <div className="flex justify-between items-baseline gap-5 w-fit max-w-[25rem]">
                        <span className="whitespace-nowrap">Income:</span>
                        <span className="text-lightPrimary text-2xl break-all dark:text-primary-gradient font-medium">
                          {formatNumber(
                            truncateToTwoDecimals(
                              Number(viewTransaction?.income ?? 0)
                            )
                          )}{" "}
                          {currency ? currency : ""}
                        </span>
                      </div>
                      <div className="flex justify-between items-baseline gap-4 w-fit max-w-[25rem]">
                        <span className="whitespace-nowrap">Expense:</span>
                        <span className="text-expense text-2xl break-all dark:text-warning font-medium">
                          {formatNumber(
                            truncateToTwoDecimals(
                              Number(viewTransaction?.expense ?? 0)
                            )
                          )}{" "}
                          {currency ? currency : ""}
                        </span>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          )}
        </div>
        <div className="mt-5 mx-4 min-h-[53vh] border border-lightPrimary/40 dark:border-info/40 mt-6 dark:bg-custom-radial bg-white">
          {selectedButton === "Pictures" && (
            <PictureComponent
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
              selectedAsset={selectedAsset}
            />
          )}
          {selectedButton === "Documents" && (
            <DocumentsComponent
              items={items}
              handleMediaDelete={confirmMediaDelete}
              mediaData={mediaData}
              handleCreateMedia={handleCreateMedia}
              setLimit={setDocumentLimit}
              limit={documentLimit}
              setPage={setDocumentPage}
              page={documentPage}
            />
          )}
          {selectedButton === "Journal" && (
            <JournalComponent journalData={journalData} />
          )}
          {selectedButton === "Legacy" && (
            <LegacyComponent
              legaciesData={legaciesData}
              selectedAsset={selectedAsset || {}}
              GetLegaciesData={GetLegaciesData}
              toast={toast}
            />
          )}
          {selectedButton === "Movements" && (
            <MovementComponent
              confirmDelete={confirmTransactionDelete}
              handleOptionSelect={handleOptionSelect}
              viewTransaction={viewTransaction}
              setLimit={setLimit}
              limit={limit}
              setPage={setPage}
              page={page}
              selectedAsset={selectedAsset}
            />
          )}
        </div>
        {type === "ADD ITEM" ? (
          <AddItemModal
            visible={modalVisible}
            singleTransactionData={singleTransactionData}
            actionTypes={actionTypes}
            fetchTransactionData={GetTransactionData}
            GetJournalData={GetJournalData}
            GetLegaciesData={GetLegaciesData}
            viewTransaction={viewTransaction}
            onHide={() => {
              setModalVisible(false);
            }}
            SelectType={type}
            toast={toast}
            loading={loading}
            setLoading={setLoading}
            assetName={selectedAsset}
            GetAddedItemData={GetAddedItemData}
          />
        ) : (
          <CreateTransactionModal
            visible={modalVisible}
            singleTransactionData={singleTransactionData}
            actionTypes={actionTypes}
            fetchTransactionData={GetTransactionData}
            GetJournalData={GetJournalData}
            GetLegaciesData={GetLegaciesData}
            viewTransaction={viewTransaction}
            onHide={() => {
              setModalVisible(false);
            }}
            SelectType={type}
            toast={toast}
            loading={loading}
            setLoading={setLoading}
            assetName={selectedAsset}
            addItems={addItems}
            items={items}
          />
        )}
      </div>
      {mediaLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-900 bg-opacity-50">
          <ProgressSpinner style={{ width: "60px", height: "60px" }} />
        </div>
      )}
    </>
  );
};

export default ViewTransaction;
